jQuery(function($) {

	// Load More Glossary Terms
	var page = 1;
	$('.load-more-terms').click(function(event) {
		event.preventDefault();

    var category = $(this).data('category');
    var tag = $(this).data('tag');

		$.ajax({
      url: ajax_object.ajax_url,
      data: {
      	action: 'load_more_terms',
      	offset: page * 12,
        category: category,
        tag: tag
    },
      success: function(data) {
      page++;
      if ( data == '' ) {
        $('.load-more-terms').hide();
        $('.load-more').html('<h3>Congrats! You reached the end of what we have for you.</h3>');
      } else {
    	 $('.glossary-cards-container').append(data);
      }
    },
    	error: function(data) {
      	console.log(data);
      }
    });

	});

  // Load More Posts
  $('.load-more-posts-button').click(function(event) {
    event.preventDefault();
    var post_page = $('.post-page').attr('data-page');
    var search_term = $('.blog-search').val();
    if(search_term) {
      var search_term_offset = 0;
    } else {
      var search_term_offset = 1;
    }
    $.ajax({
      url: ajax_object.ajax_url,
      data: {
        action: 'load_more_posts',
        offset: (post_page * 12) + search_term_offset,
        search_term: search_term
    },
    success: function(data) {
      var found_posts = $(data).filter('.found-posts').attr('data-posts');
      if(((post_page * 12) + search_term_offset) < found_posts){
        $('.post-card-container .grid').append(data);
      }
      post_page++;
      $('.post-page').attr('data-page', post_page);
      if(((post_page * 12) + search_term_offset) > found_posts) {
        $('.load-more-posts-button').hide();
        $('.blog-end').show();
      } else {
        $('.load-more-posts-button').show();
        $('.blog-end').hide();
      }
    },
      error: function(data) {
        console.log(data);
      }
    });

  });


});